import { HttpHeaders, HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { requestManutencaoEnvioCte, requestSalvarCTeConfiguracao, responseManutencaoEnvioCte, requestGerarLotes} from 'src/app/@shared/models/manutencao-envio-cte';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filtro = (obj: requestManutencaoEnvioCte | requestSalvarCTeConfiguracao) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
};

@Injectable({
  providedIn: 'root'
})
export class ManutencaoEnvioCteService {
  constructor(private http: HttpClient) { }

  public consultaEnvioCte(obj: requestManutencaoEnvioCte): Observable<responseManutencaoEnvioCte[]> {
    return this.http.get<responseManutencaoEnvioCte[]>(
      `EnvioCTeConfiguracao/ConsultaManutencaoEnvioCte?${filtro(obj)}`,
      httpOptions
    );
  }

  public exportarExcel(obj: requestManutencaoEnvioCte): Observable<any> {
    return this.http.get<any>(
      `EnvioCTeConfiguracao/ExportarExcel?${filtro(obj)}`,
      httpOptions
    );
  }

  public salvarCTeConfiguracao(obj: requestSalvarCTeConfiguracao): Observable<any> {
    return obj.envioConfiguracaoId ?
      this.http.put<any>(`EnvioCTeConfiguracao/AtualizaCTeConfiguracao`, obj, httpOptions) :
      this.http.post<any>(`EnvioCTeConfiguracao/SalvarCTeConfiguracao`, obj, httpOptions)
  }

  public obterDetalhesEnvioCTE(obj: requestSalvarCTeConfiguracao): Observable<any> {
    return this.http.post<any>(`EnvioCTeConfiguracao/DetalhesCTeConfiguracao`, obj, httpOptions)
  }

  public consultaListaTipoEnvioCTE(): Observable<any> {
    return this.http.get<any>(`EnvioCTeConfiguracao/ConsultaListaTipoEnvioCTe`, httpOptions);
  }

  public consultaListaTipoCTE(): Observable<any> {
    return this.http.get<any>(`EnvioCTeConfiguracao/ConsultaListaTipoCTe`, httpOptions);
  }

  public consultaListaTipoProcessamento(): Observable<any> {
    return this.http.get<any>(`EnvioCTeConfiguracao/ConsultaListaTipoProcessamento`, httpOptions);
  }

  public consultaListaParams(tipoEnvio: number, configuracaoId: number = null): Observable<any> {
    return this.http.get<any>(`EnvioCTeConfiguracao/ConsultaListaTipoEnvioCTeParams/${configuracaoId ?? ""}?tipoEnvioCteId=${tipoEnvio}`, httpOptions);
  }

  public consultaDetalhesCTE(id: number): Observable<any> {
    return this.http.get<any>(`EnvioCTeConfiguracao/ConsultaEnvioCteConfiguracaoPorId?cteConfiguracaoId=${id}`, httpOptions);
  }

}
